import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;


export function useRooms() {
    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchRooms = async () => {
        try {
            setLoading(true);

            const response = await fetch(`${API_URL}/rooms`);

            if (!response.ok) {
                throw new Error("Errore nel recupero delle stanze");
            }

            const data = await response.json();

            setRooms(data);
            setError(null);

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRooms();
    }, []);

    const addPatient = async (roomId, patient) => {
        const response = await fetch(
            `${API_URL}/rooms/${roomId}/patients`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(patient)
            }
        );

        if (!response.ok) {
            throw new Error("Errore nell'aggiunta del paziente");
        }

        const newPatient = await response.json();

        setRooms(prevRooms =>
            prevRooms.map(room =>
                room.id === roomId
                    ? {
                        ...room,
                        patients: [...room.patients, newPatient]
                    }
                    : room
            )
        );

        return newPatient;
    };

    const deletePatient = async (roomId, patientId) => {
        const response = await fetch(
            `${API_URL}/rooms/${roomId}/patients/${patientId}`,
            {
                method: "DELETE"
            }
        );

        if (!response.ok) {
            throw new Error("Errore nell'eliminazione del paziente");
        }

        setRooms(prevRooms =>
            prevRooms.map(room =>
                room.id === roomId
                    ? {
                        ...room,
                        patients: room.patients.filter(
                            patient => patient.id !== patientId
                        )
                    }
                    : room
            )
        );
    };

    const updatePatient = async (
        roomId,
        patientId,
        patient
    ) => {
        const response = await fetch(
            `${API_URL}/rooms/${roomId}/patients/${patientId}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(patient)
            }
        );

        if (!response.ok) {
            throw new Error("Errore nella modifica del paziente");
        }

        const updatedPatient = await response.json();

        setRooms(prevRooms =>
            prevRooms.map(room =>
                room.id === roomId
                    ? {
                        ...room,
                        patients: room.patients.map(patient =>
                            patient.id === patientId
                                ? updatedPatient
                                : patient
                        )
                    }
                    : room
            )
        );

        return updatedPatient;
    };

    return {
        rooms,
        loading,
        error,
        fetchRooms,
        addPatient,
        deletePatient,
        updatePatient
    };
}